<div>
  <div [class.search-panel]="isMobileSearchOpen && !isSpSearch">
    <div [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search">
      <label class="searchbox" [class.dirty]="!!searchInput.value">

        <div class="inner-container">
          <div class="search-icon prefix" *ngIf="!!searchInput.value && !isSpSearch">
            <img src="../../../../../assets/icons/search-grey_icon.svg" alt="search">
          </div>

          <input #searchInput
            [placeholder]="searchPlaceholder | cxTranslate" 
            autocomplete="off" 
            aria-describedby="initialDescription" 
            aria-controls="results"
            [attr.aria-label]="'searchBox.placeholder' | cxTranslate" 
            (click)="search(searchInput.value); openMobileSearch()"
            (input)="onInput(searchInput.value)"
            (paste)="onInput(searchInput.value)"
            (blur)="onBlur(searchInput)"
            (focus)="onFocus(searchInput)"
            (keydown.enter)="onEnter(searchInput.value)"
            (keydown.arrowup)="focusPreviousChild($any($event))" 
            (keydown.arrowdown)="focusNextChild($any($event))"
            [value]="isSpSearch ? getSpSearchInputValue(chosenWord) : chosenWord"
          />

          <button [attr.aria-label]="'common.reset' | cxTranslate"
            (mousedown)="isSpSearch ? clearSpSearch(searchInput) : clear(searchInput)"
            (keydown.enter)="isSpSearch ? clearSpSearch(searchInput) : clear(searchInput)" class="reset"
            [ngClass]="{'has-sp-selector': isServicePartsEnabled}">
            <cx-icon [type]="iconTypes.RESET"></cx-icon>
          </button>

          <button *ngIf="isSpSearch" class="search">
            <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
          </button>

          <div class="search-icon suffix" *ngIf="!isSpSearch">
            <button type="button" (click)="onClickSearch(searchInput.value)">
              <img src="../../../../../assets/icons/search-orange_icon.svg" alt="search">
            </button>
          </div>
        </div>

        <ng-container *ngIf="!isSpSearch">
          <button type="button" class="cancel" (click)="onClickCancel(searchInput)">Cancel</button>

          <gen-service-parts-search-button *ngIf="isServicePartsEnabled"></gen-service-parts-search-button>
        </ng-container>
      </label>
    </div>

    <ng-container *ngIf="searchInput?.value?.length > 0 || isMobileSearchOpen">
      <div *ngIf="results$ | async as result" class="results" id="results" (click)="close(true)" role="dialog"
        [ngClass]="{'results-hidden': !!selectedSpSearchProduct?.code}">

        <div class="results-content">
          <div *ngIf="result.message" class="message" [innerHTML]="result.message"></div>
          <ul *ngIf="!isSpSearch" class="suggestions" attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}"
            role="listbox">
            <li *ngFor="let suggestion of result.suggestions">
              <a class="list-link" role="option"
                (keydown.arrowup)="focusPreviousChild($any($event))" 
                (keydown.arrowdown)="focusNextChild($any($event))"
                (keydown.enter)="close(true)" (keydown.escape)="close(true)" (blur)="close(true)"
                (mousedown)="preventDefault($event)" (click)="
                  dispatchSuggestionEvent({
                    freeText: searchInput.value,
                    selectedSuggestion: suggestion,
                    searchSuggestions: result.suggestions ?? []
                  });
                  updateChosenWord(suggestion);"
              >
                <div class="search-icon-prefix">
                  <img src="../../../../../assets/icons/search-grey_icon.svg" alt="search">
                </div>
                <div class="name" [innerHTML]="suggestion | cxHighlight: searchInput.value"></div>
              </a>
            </li>
          </ul>

          <div *ngIf="isSpSearch && result?.products?.length > 0 && searchInput?.value?.length > 2" class="sp-search-products-header">
            {{ 'searchBox.spSearchMatches' | cxTranslate: { amount: result.products.length } }}
          </div>

          <ul class="products"
            *ngIf="(!isSpSearch && result.products) || (result.products && isSpSearch && searchInput?.value?.length > 2)"
            attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}" role="listbox">
            <li *ngFor="let product of result.products">
              <ng-container *ngIf="!isSpSearch; else spSearchProductTemplate">
                <a class="list-link" role="option" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
                  [class.has-media]="config?.displayProductImages" (keydown.arrowup)="focusPreviousChild($any($event))"
                  (keydown.arrowdown)="focusNextChild($any($event))" (keydown.enter)="close(true)"
                  (keydown.escape)="close(true)" (blur)="close($any($event))" (mousedown)="preventDefault($event)"
                  (click)="dispatchProductEvent({freeText: searchInput.value, productCode: product.code }); closeMobileSearch()">
                  <cx-media
                    *ngIf="config?.displayProductImages && ((product.servicePart && product.images?.PRIMARY) || !product.servicePart); else spGearThumb"
                    [container]="product.images?.PRIMARY" format="thumbnail" role="presentation"></cx-media>
                  <ng-template #spGearThumb>
                    <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear" class="sp-gear-thumb">
                  </ng-template>
                  <div class="name" [innerHTML]="product.nameHtml"></div>
                  <span class="price">{{ product.price?.formattedValue }}</span>
                </a>
              </ng-container>
              <ng-template #spSearchProductTemplate>
                <a class="list-link sp-search-list-link" role="option" (mousedown)="preventDefault($event)"
                  (click)="selectSpSearchProduct(product); searchInput.blur();">
                  <div class="product-info">
                    <div class="name">
                      {{product?.code}} {{ product?.nameHtml?.length > 0 ? ' - ' : '' }}
                      <span [innerHTML]="product.nameHtml"></span>
                    </div>
                    <div class="category" *ngIf="product?.categories?.length > 0">
                      <span [innerHTML]="product.categories[0].name"></span>
                    </div>
                  </div>
                  <cx-icon [type]="iconTypes.CARET_RIGHT"></cx-icon>
                </a>
              </ng-template>
            </li>
          </ul>
          <span id="initialDescription" class="cx-visually-hidden">
            {{ 'searchBox.initialDescription' | cxTranslate }}
          </span>
          <div *ngIf="result.suggestions?.length || result.products?.length" aria-live="assertive"
            class="cx-visually-hidden">
            {{ 'searchBox.suggestionsResult' | cxTranslate: { count: result.suggestions?.length } }}
            {{ 'searchBox.productsResult' | cxTranslate: { count: result.products?.length } }}
            {{ 'searchBox.initialDescription' | cxTranslate }}
          </div>

          <div class="suggestions-footer" *ngIf="!isSpSearch">
            <a class="find-parts-link" (click)="onClickFindParts(searchInput)">
               {{ 'searchBox.findPartsCta' | cxTranslate }}
              <cx-icon [type]="iconTypes.ARROW_RIGHT"></cx-icon>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>